module.exports = __webpack_public_path__ + "static/gift-box-mobile-c192c0701f3db3ff81eae1f100bd0895.jpg";